@if (allowanceEntity$ | async) {
  <form (change)="saveForm()" [formGroup]="formGroup">
    @if (woningen.length > 0) {
      <div formArrayName="huurwoningen">
        @for (item of woningen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Postcode' : ''"
                                              class="custom-input-100"
                                              formControlName="postcode"
                                              id="postcode"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Huisnr' : ''"
                                              class="custom-input-75"
                                              formControlName="huisnummer"
                                              id="huisnummer"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Toev.' : ''"
                                              class="custom-input-75"
                                              formControlName="huisnummerToevoeging"
                                              id="huisnummerToevoeging"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Woonplaats' : ''"
                                              class="custom-input-150"
                                              formControlName="woonplaats"
                                              id="woonplaats"
              >
              </snelstart-ui-text-form-control>
              <div class="row col-auto" formGroupName="bewoondePeriode" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-date-form-control [label]="i === 0 ? 'Bewoond van' : ''"
                                                class="custom-input-150"
                                                formControlName="begindatum"
                                                id="begindatum"
                                                placeholder="dd-mm-{{this.year}}"
                >
                </snelstart-ui-date-form-control>
                <snelstart-ui-date-form-control [label]="i === 0 ? 'Bewoond t/m' : ''"
                                                class="custom-input-150"
                                                formControlName="einddatum"
                                                id="einddatum"
                                                placeholder="dd-mm-{{this.year}}"
                >
                </snelstart-ui-date-form-control>
              </div>
              <snelstart-ui-button (click)="this.showDialog(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="plus"
                                   type="secondary">Huurgegevens
              </snelstart-ui-button>
              <snelstart-ui-button (click)="this.showDialogMedebewoner(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="plus"
                                   type="secondary">Medebewoners
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDelete"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancelB"
                       type="link">Woning toevoegen
  </snelstart-ui-button>
}

<snelstart-ui-dialog-definition (close)="dialogVisible=false" [(visible)]="dialogVisible" id="huurwoningGegevens"
                                size="lg" title="Gegevens huurprijs en kosten (t/m 2025) van de huurwoning">
  <snelstart-ui-dialog-body>
    <form (change)="saveForm()" [formGroup]="formGroup">
      @if (woningen.length > 0) {
        <div formArrayName="huurwoningen">
          @for (item of woningen.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              @if (i === this.index) {
                <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="kaleHuurprijsPerMaand"
                                                  id="kaleHuurprijsPerMaand"
                                                  label="Kale huurprijs per maand"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              }
              @if ((allowanceEntity$ | async)?.year! < 2026) {
                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="energiekostenPerMaand"
                                                  id="energiekostenPerMaand"
                                                  label="Energiekosten gemeensch. ruimten "
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="schoonmaakkostenPerMaand"
                                                  id="schoonmaakkostenPerMaand"
                                                  label="Schoonmaakkosten gemeensch. ruimten "
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="huismeersterkostenPerMaand"
                                                  id="huismeersterkostenPerMaand"
                                                  label="Huismeesterkosten"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-250"
                                                  formControlName="algemeneservicePerMaand"
                                                  id="algemeneservicePerMaand"
                                                  label="Kosten dienst- en recreatieruimten "
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              }
            </div>
          }
        </div>
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancelE" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button (click)="!this.dialogVisible" icon="check" id="save" type="primary">Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition (close)="dialogMedebewonerVisible=false" [(visible)]="dialogMedebewonerVisible"
                                id="medebewonersGegevens" size="xl" title="Gegevens medebewoners">
  <snelstart-ui-dialog-header-content>
    Vul de gegevens van de medebewoner(s) in en kies de periode dat de betreffende medebewoner op hetzelfde
    adres als de aanvrager ingeschreven stond in {{ (allowanceEntity$ | async)?.year! }}.
  </snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    <form (change)="saveForm()" [formGroup]="formGroup">
      @if (woningen.length > 0) {
        <div formArrayName="huurwoningen">
          @for (item of woningen.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              @if (i === this.index) {
                <div formArrayName="medebewoners">
                  @for (medebewoner of getMedebewoners(i).controls; track medebewoner; let j = $index) {
                    <div [formGroupName]="j" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                      <snelstart-ui-text-form-control [label]="j === 0 ? 'Naam medebewoner' : ''"
                                                      class="custom-input-200"
                                                      formControlName="naam"
                                                      id="naam-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-text-form-control>
                      <snelstart-ui-date-form-control [label]="j === 0 ? 'Geboortedatum' : ''"
                                                      class="custom-input-150"
                                                      formControlName="geboortedatum"
                                                      id="geboortedatum-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-date-form-control>
                      <snelstart-ui-bsn-form-control [label]="j === 0 ? 'Bsn' : ''"
                                                     class="custom-input-150"
                                                     formControlName="bsn"
                                                     id="bsn-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-bsn-form-control>
                      <snelstart-ui-number-form-control [label]="j === 0 ? 'Toetsinkomen ' : ''"
                                                        [showAllDecimals]="false"
                                                        align="right" class="custom-input-125"
                                                        formControlName="inkomen"
                                                        id="inkomen-{{ i }}-{{ j }}"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                      <snelstart-ui-number-form-control [label]="j === 0 ? 'Toetsvermogen ' : ''"
                                                        [showAllDecimals]="false"
                                                        align="right" class="custom-input-125"
                                                        formControlName="toetsvermogen"
                                                        id="toetsvermogen-{{ i }}-{{ j }}"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                      <div formGroupName="periodeSamenwonend" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                        <snelstart-ui-date-form-control [label]="j === 0 ? 'Begindatum' : ''"
                                                        class="custom-input-150"
                                                        formControlName="begindatum"
                                                        id="begindatumSamenwonen-{{ i }}-{{ j }}"
                                                        placeholder="dd-mm-{{ this.year }}"
                        >
                        </snelstart-ui-date-form-control>
                        <snelstart-ui-date-form-control [label]="j === 0 ? 'Einddatum' : ''"
                                                        class="custom-input-150"
                                                        formControlName="einddatum"
                                                        id="einddatumSamenwonen-{{ i }}-{{ j }}"
                                                        placeholder="dd-mm-{{ this.year }}"
                        >
                        </snelstart-ui-date-form-control>
                      </div>
                      <snelstart-ui-button (click)="verwijderMedebewoner(i, j)"
                                           [class]="j === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                           icon="trash"
                                           iconType="light"
                                           id="buttonDeleteMedebewoner-{{ i }}-{{ j }}"
                                           size="medium"
                                           type="secondary"
                      >
                      </snelstart-ui-button>
                    </div>
                  }
                </div>
                <snelstart-ui-button (click)="addMedebewoner(i)"
                                     class="snelstart-ui-button" icon="plus"
                                     id="addMedebewoner-{{ i }}"
                                     type="link">
                  Medebewoner toevoegen
                </snelstart-ui-button>
              }
            </div>
          }
        </div>
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancelF" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button (click)="!this.dialogMedebewonerVisible" icon="check" id="save1" type="primary">Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
